module.exports = __webpack_public_path__ + "static/media/hajj-package-5.2e3a4f27.jpg";